import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";

export const Container = ({
    children,
    centered,
    className,
}: {
    children: React.ReactNode;
    centered?: boolean;
    className?: string;
}) => {
    return (
        <AnimatePresence>
            <motion.main
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={clsx(
                    "min-h-screen lg:max-h-screen lg:overflow-hidden",
                    centered
                        ? "flex justify-center px-10 lg:px-0"
                        : "px-10 pt-20 lg:px-[100px] xl:px-[180px] 2xl:px-[300px]",
                    className,
                )}
            >
                {children}
            </motion.main>
        </AnimatePresence>
    );
};
